(function () {
  function syncNewsletterConsentForm(form) {
    if (!form) return;
    var cb = form.querySelector('input[type="checkbox"][data-newsletter-marketing-consent]');
    if (!cb) return;
    var btn =
      form.querySelector('button[name="commit"].wt-newsletter__send') ||
      form.querySelector('button[name="commit"]') ||
      form.querySelector('button[type="submit"]');
    if (!btn) return;
    var email = form.querySelector('input[type="email"]');
    var emailValid = !email || (email.value.trim() !== '' && email.validity.valid);
    var enable = !!cb.checked && emailValid;
    btn.disabled = !enable;
    if (enable) {
      btn.removeAttribute('disabled');
    } else {
      btn.setAttribute('disabled', '');
    }
    var msg = form.querySelector('[data-newsletter-consent-error]');
    if (msg && cb.checked) msg.hidden = true;
  }

  function isNewsletterConsentForm(form) {
    return (
      form &&
      form.nodeName === 'FORM' &&
      form.querySelector('[data-newsletter-marketing-consent]') &&
      (form.classList.contains('wt-newsletter__form--with-consent') ||
        form.classList.contains('newsletter-form'))
    );
  }

  function initAllNewsletterConsentForms() {
    document.querySelectorAll('form').forEach(function (form) {
      if (isNewsletterConsentForm(form)) syncNewsletterConsentForm(form);
    });
  }

  function onCheckboxInteraction(e) {
    var el = e.target;
    if (!el || el.nodeName !== 'INPUT' || el.type !== 'checkbox') return;
    if (!el.hasAttribute('data-newsletter-marketing-consent')) return;
    var form = el.closest('form');
    if (form) syncNewsletterConsentForm(form);
  }

  function onFormInput(e) {
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (isNewsletterConsentForm(form)) syncNewsletterConsentForm(form);
  }

  document.addEventListener('change', onCheckboxInteraction);
  document.addEventListener('input', onFormInput);

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isNewsletterConsentForm(form)) return;
      var cb = form.querySelector('[data-newsletter-marketing-consent]');
      if (!cb || cb.checked) return;
      e.preventDefault();
      var msg = form.querySelector('[data-newsletter-consent-error]');
      if (msg) {
        msg.hidden = false;
        msg.focus();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllNewsletterConsentForms);
  } else {
    initAllNewsletterConsentForms();
  }
})();
